import {
  ProductClass,
} from '../../graphQL/types/shared';
import { extractFromStringProductId, generateStringProductId } from '../../graphQL/Utils';
import {
  ILoadable,
  LoadableStatus,
  ProductMetadatumLevel as Level,
} from '../../Utils';
import {
  GroupGetter,
  IAssignGroupOutput,
  IAssignSectionOutput,
  IDatumWithSection,
  IDatumWithSectionAndGroup,
} from './Utils';

const assign = (
    level: Level,
    high2LowStatus: ILoadable<Record<string, number>>,
    high2MidStatus: ILoadable<Record<string, number>>,
    sectionAssignedStatus: ILoadable<IAssignSectionOutput>,
    productClass: ProductClass,
  ): ILoadable<IAssignGroupOutput> => {

  let result: ILoadable<IAssignGroupOutput>;
  if (sectionAssignedStatus.status === LoadableStatus.Initial ||
      high2LowStatus.status === LoadableStatus.Initial ||
      high2MidStatus.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (sectionAssignedStatus.status === LoadableStatus.Loading ||
              high2LowStatus.status === LoadableStatus.Loading ||
              high2MidStatus.status === LoadableStatus.Loading) {
    result = {status: LoadableStatus.Loading};
  } else if (sectionAssignedStatus.status === LoadableStatus.NotPresent ||
              high2LowStatus.status === LoadableStatus.NotPresent ||
              high2MidStatus.status === LoadableStatus.NotPresent) {
    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: {
      nodes: withSection,
      minWorldTrade, maxWorldTrade,
      minOpportunityGain, maxOpportunityGain,
      minDistance, maxDistance,
      minComplexity, maxComplexity,
    }} = sectionAssignedStatus;
    const {data: high2Low} = high2LowStatus;
    const {data: high2Mid} = high2MidStatus;

    let getGroup: GroupGetter;
    if (level === Level.fourDigit) {
      getGroup = ({product_id}: IDatumWithSection) => product_id;
    } else if (level === Level.twoDigit) {
      getGroup = ({product_id}: IDatumWithSection) => {
        const id = high2Mid[extractFromStringProductId(product_id).id];
        return generateStringProductId({productClass, id});
      };
    } else {
      getGroup = ({product_id}: IDatumWithSection) => {
        const id = high2Low[extractFromStringProductId(product_id).id];
        return generateStringProductId({productClass, id});
      };
    }
    const withSectionAndGroup: IDatumWithSectionAndGroup[] = withSection.map(datum => ({
      ...datum,
      group: getGroup(datum),
    }));
    result = {
      status: LoadableStatus.Present,
      data: {
        nodes: withSectionAndGroup,
        minWorldTrade, maxWorldTrade,
        minOpportunityGain, maxOpportunityGain,
        minDistance, maxDistance,
        minComplexity, maxComplexity,
      },
    };
  }
  return result;
};

export default assign;
